import { Grid, Typography } from "@mui/material";
import React from "react";
import theme from "../../theme";

const ActivityLogNew = (props: any) => {
  const { createdAt, createdBy, title } = props;
  return (
    <Grid p={1}>
      <Grid borderBottom={theme.border?.smallGrey}>
        <Grid display={"flex"} sx={{ color: "#667085" }} mb={0.2} gap={1}>
          <Typography
            width={"70%"}
            textAlign={"left"}
            sx={{
              fontWeight: 400,
              fontFamily: theme.font?.fontFamily.primary,
              fontSize: "12px",
            }}
          >
            {title}
          </Typography>
          <Typography
            width={"30%"}
            sx={{
              fontWeight: 400,
              fontFamily: theme.font?.fontFamily.primary,
              fontSize: "12px",
              textTransform: "capitalize",
            }}
          >
            {createdBy}
          </Typography>
        </Grid>
        <Grid>
          <Typography
            textAlign={"left"}
            sx={{
              color: "#C5C5C5",
              fontWeight: 400,
              fontFamily: theme.font?.fontFamily.primary,
              fontSize: "12px",
            }}
          >
            {createdAt}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ActivityLogNew;
